// signal.service.ts
import { Injectable, } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MasterSignalService {
 private masterTabNameSubject = new BehaviorSubject<string>('');

  // Observable
  masterTabName$ = this.masterTabNameSubject.asObservable();

  // Getter (optional)
  get masterTabName(): string {
    return this.masterTabNameSubject.value;
  }

  // Setter
  setMasterTabName(name: string): void {
    this.masterTabNameSubject.next(name);
  }
}